export default __webpack_public_path__ + "src/assets/reddit.1c32f5814b1251bfe72b38bb5631fc43.svg";